import { Button, ButtonProps, Stack } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { useRouteMatch } from '@/hooks/useRouteMatch';

export const NavigationButtonMenuable: React.FC<
  ButtonProps & {
    text: string;
    href: string;
    matchHref?: string;
    isExact?: boolean;
    newView?: boolean;
  }
> = ({ text, href, matchHref, isExact, newView, children, ...props }) => {
  const isRouteMatch = useRouteMatch(matchHref ?? href, {
    isExact,
  });

  return (
    <>
      <Button
        as={NextLink}
        href={href}
        variant="ghost"
        size="md"
        justifyContent="left"
        colorScheme="gray"
        isActive={!!children ? false : isRouteMatch}
        rounded="xl"
        color={isRouteMatch ? 'textPrimary.500' : 'textSecondary.500'}
        borderLeft={newView && isRouteMatch ? "5px solid" : "5px solid"}
        borderColor={newView && isRouteMatch ? "primary.500" : "transparent"}
        borderRadius={newView && isRouteMatch ? "0 6px 6px 0" : "6px 6px 6px 6px"}
        {...props}
      >
        {text}
      </Button>
      {isRouteMatch && !!children && <Stack pl="6">{children}</Stack>}
    </>
  );
};
